// Tiny localStorage helpers with JSON parse + safe fallback.

export function lsGet(key, fallback) {
    try {
        const v = localStorage.getItem(key);
        if (v === null || v === undefined) return fallback;
        return JSON.parse(v);
    } catch {
        return fallback;
    }
}

export function lsSet(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // ignore quota / private-mode errors
    }
}

export function lsRemove(key) {
    try { localStorage.removeItem(key); } catch { /* ignore */ }
}

// Acknowledgement helpers — keyed by sectionId + headingSlug
const ACK_KEY = "bscc.acks.v1";
const CLIENT_KEY = "bscc.client.id.v1";

export function getClientId() {
    let id = lsGet(CLIENT_KEY, null);
    if (!id) {
        id = `c-${Math.random().toString(36).slice(2, 10)}-${Date.now().toString(36)}`;
        lsSet(CLIENT_KEY, id);
    }
    return id;
}

export function getAcks() {
    return lsGet(ACK_KEY, {});
}

export function setAck(sectionId, slug, value) {
    const all = getAcks();
    all[sectionId] = all[sectionId] || {};
    if (value) all[sectionId][slug] = new Date().toISOString();
    else delete all[sectionId][slug];
    lsSet(ACK_KEY, all);
}

export function clearAcks(sectionId) {
    const all = getAcks();
    if (sectionId) delete all[sectionId]; else Object.keys(all).forEach(k => delete all[k]);
    lsSet(ACK_KEY, all);
}
